export const projects = [
    {
        id: 0,
        src: require('../img/Home - Unlabeled Elite Ent.png').default,
        alt: 'image',
        Header:'Unlabeled Elite Ent',
        project_url: 'https://www.unlabeledent.com/'
    },
    {
        id: 1,
        src: require('../img/memories.png').default,
        alt: "Mern Stack Development",
        Header:'Memories ',
        project_url: 'https://zen-archimedes-8bb25b.netlify.app/'
    },    
    {
        id: 2,
        src: require('../img/inProgress.webp').default,
        alt: "Projects Coming Soon!",      
        Header:'in Progress',
        project_url: null
    }
    ,    
    {
        id: 3,
        src: require('../img/inProgress.webp').default,
        alt: 'Projects Coming Soon!',
        Header:'in Progress',
        project_url: null
    }
    ,    
    {
        id: 4,
        src: require('../img/inProgress.webp').default,
        alt: 'Projects Coming Soon!',
        Header:'in Progress',
        project_url: null
    }
    ,    
    {
        id: 5,
        src: require('../img/inProgress.webp').default,
        alt: 'Projects Coming Soon!',
        Header:'in Progress',
        project_url: null
    }
    ,    
    {
        id: 6,
        src: require('../img/inProgress.webp').default,
        alt: 'Projects Coming Soon!',
        Header:'in Progress',
        project_url: null
    }
    ,    
    {
        id: 7,
        src: require('../img/inProgress.webp').default,
        alt: 'Projects Coming Soon!',
        Header:'in Progress',
        project_url: null
    }
    ,    
    {
        id: 8,
        src: require('../img/inProgress.webp').default,
        alt: 'Projects Coming Soon!',
        Header:'in Progress',
        project_url: null
    }
    ,    
    {
        id: 9,
        src: require('../img/inProgress.webp').default,
        alt: 'Projects Coming Soon!',
        Header:'in Progress',
        project_url: null
    }
    ,    
    {
        id: 10,
        src: require('../img/inProgress.webp').default,
        alt: 'Projects Coming Soon!',
        Header:'in Progress',
        project_url: null
    }
    ,    
    {
        id: 11,
        src: require('../img/inProgress.webp').default,
        alt: 'Projects Coming Soon!',
        Header:'in Progress',
        project_url: null
    }
    
]